import state from './store/state';
import getters from './store/getters';
import mutations from './store/mutations';
import actions from './store/actions';

export const name = '$_studentProvisionalRemedyAnswer';
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
